module.exports = __webpack_public_path__ + "68bcb18c08f740257f6531e52339dc95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/d/d06.jpg
// module id = 508
// module chunks = 0